<div class="card" rte="ie">
    <div class="flex align-items-center" [style.margin-bottom.rem]="1.5">
        <h1 [style.margin]="0">Database Menu Items</h1>
        <p-button label="Menu Designer" icon="pi pi-arrow-left" size="small" routerLink=".." styleClass="ml-2" />
    </div>
    <grid [gridSettings]="gridSettings" [tableSettings]="tableSettings">
        <ng-template gridColumnTemplate="displayingRow" columnName="databaseItem" let-rowData>
            <ng-container
                *ngTemplateOutlet="
                    lhsMenuItem;
                    context: {
                        $implicit: {
                            icon: rowData.icon,
                            miproIcon: rowData.miproIcon,
                            label: rowData.label,
                            routerLink: rowData.routerLink
                        }
                    }
                "></ng-container>
        </ng-template>

        <ng-template gridColumnTemplate="displayingRow" columnName="parentItem" let-rowData>
            <ng-container
                *ngTemplateOutlet="
                    lhsMenuItem;
                    context: {
                        $implicit: {
                            icon: rowData.parentIcon,
                            miproIcon: rowData.parentMiproIcon,
                            label: rowData.parentLabel,
                        }
                    }
                "></ng-container>
        </ng-template>
    </grid>
</div>

<ng-template #lhsMenuItem let-item>
    <div class="flex align-items-start menu-item">
        <i *ngIf="item.miproIcon || item.icon" class="menu-item-icon" [ngClass]="{ 'material-icons': item.icon, mi: item.miproIcon }">
            {{ item.miproIcon ?? item.icon }}
        </i>
        <div class="flex flex-column">
            <span class="menu-item-label">{{ item.label }}</span>
            <span *ngIf="item.routerLink" class="menu-item-router-link">{{ item.routerLink }}</span>
        </div>
    </div>
</ng-template>

<select-parent-dialog [(visible)]="isUpdatingItem" (parentSelected)="onParentSelected()" [itemId]="updatingItemId"></select-parent-dialog>
